import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import tagsService from "../../services/tagsService";

// Queries
export const useGetTag = (tagID, queryOptions = {}) => {
  return useQuery(["tags", tagID], () => tagsService.get(tagID), queryOptions);
};

export const useGetTags = (queryOptions = {}) => {
  return useQuery(["tags"], () => tagsService.index(), queryOptions);
};

// Mutations
export const useUpdateTag = (tagID, mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation((tagParams) => tagsService.update(tagID, tagParams), {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["tags", tagID], data);
      mutationOptions.onSuccess(data);
    },
  });
};

export const useCreateTag = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation((tagParams) => tagsService.create(tagParams), {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["tags", data.id], data);
      mutationOptions.onSuccess(data);
    },
  });
};

export const useDeleteTag = (tagID, mutationOptions = {}) => {
  return useMutation(() => tagsService.delete(tagID), mutationOptions);
};

export const useBulkDeleteTags = (mutationOptions = {}) => {
  const queryClient = useQueryClient();
  return useMutation((tagIDs) => tagsService.bulkDelete(tagIDs), {
    ...mutationOptions,
    onSuccess: (data) => {
      queryClient.setQueryData(["tags"], data);
      mutationOptions.onSuccess(data);
    },
  });
};
